import type { HelpFile } from '../../types/help'
import { EscalationThresholdsTestIds } from '../../../testids/EscalationThresholdsTestIds'

export const escalationThresholdsHelp: HelpFile = {
  docPage: '/docs/governance/workflow-escalations',
  texts: {
    [EscalationThresholdsTestIds.escalationThresholdsList]:
      'Configurable cadence and recipients per request type and risk level. Editing affects only newly activated steps.',
    [EscalationThresholdsTestIds.editThresholdDialog]:
      'Edit cadence days, manager target and the IAM Platform Owner for this threshold row.',
    [EscalationThresholdsTestIds.inputReminderDays]:
      'Days after activation before the first reminder notification fires.',
    [EscalationThresholdsTestIds.inputFinalReminderDays]:
      'Days after activation before the final reminder fires — must exceed reminder days.',
    [EscalationThresholdsTestIds.inputManagerDays]:
      'Days after activation before the step escalates to the manager — must exceed final reminder days.',
    [EscalationThresholdsTestIds.inputPlatformOwnerDays]:
      'Additional days after manager escalation before the IAM Platform Owner is notified.',
    [EscalationThresholdsTestIds.selectManagerTarget]:
      'Which manager receives the escalation: the current approver’s manager or the object owner’s manager.',
    [EscalationThresholdsTestIds.checkboxActive]:
      'Inactive threshold rows are skipped at step activation; existing snapshots stay frozen.',
    [EscalationThresholdsTestIds.thRequestType]: null,
    [EscalationThresholdsTestIds.thRiskLevel]: null,
    [EscalationThresholdsTestIds.thReminderDays]: null,
    [EscalationThresholdsTestIds.thFinalReminderDays]: null,
    [EscalationThresholdsTestIds.thManagerDays]: null,
    [EscalationThresholdsTestIds.thPlatformOwnerDays]: null,
    [EscalationThresholdsTestIds.thManagerTarget]: null,
    [EscalationThresholdsTestIds.thActive]: null,
    [EscalationThresholdsTestIds.thActiveSnapshots]: null,
    [EscalationThresholdsTestIds.thActions]: null,
  },
}
